import { ChecksumError } from 'errors';

function decodeBase64(base64: string) {
  const binaryString = window.atob(base64);
  const length = binaryString.length;

  const bytes = new Uint8Array(length);
  for (let index = 0; index < length; index++) {
    const codePoint = binaryString.codePointAt(index);
    if (codePoint === undefined) {
      throw new Error('Invalid character code');
    }

    bytes[index] = codePoint;
  }

  return bytes;
}

function encodeBase64(buffer: ArrayBuffer): string {
  const binary = String.fromCodePoint(...new Uint8Array(buffer));
  return window.btoa(binary);
}

async function sha256Digest(data: ArrayBuffer) {
  return crypto.subtle.digest('SHA-256', data);
}

export async function calculateSha256Checksum(chunk: Blob) {
  try {
    const arrayBuffer = await chunk.arrayBuffer();
    const hash = await sha256Digest(arrayBuffer);
    return encodeBase64(hash);
  } catch (error: unknown) {
    throw error instanceof Error
      ? new ChecksumError(error)
      : new Error('Unknown error occurred while calculating checksum');
  }
}

export async function calculateFinalSha256Checksum({ checksums }: { checksums: string[] }) {
  try {
    const checksumsBufferArray = checksums.map((checksum) => decodeBase64(checksum));
    const concatenatedBuffer = new Uint8Array(
      checksumsBufferArray.reduce((accumulator, value) => accumulator + value.length, 0),
    );

    let offset = 0;
    for (const checksum of checksumsBufferArray) {
      concatenatedBuffer.set(checksum, offset);
      offset += checksum.length;
    }

    const hash = await sha256Digest(concatenatedBuffer);
    return encodeBase64(hash);
  } catch (error: unknown) {
    throw error instanceof Error
      ? new ChecksumError(error)
      : new Error('Unknown error occurred while calculating final checksum');
  }
}
